import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createBlock(_component_q_input, {
    "model-value": _ctx.reportPost.comment,
    placeholder: "Add External Comments Here...",
    autogrow: "",
    borderless: "",
    "onUpdate:modelValue": _ctx.onInput
  }, null, 8, ["model-value", "onUpdate:modelValue"]))
}